// src/components/TermsOfService.js
import React from 'react';
import './TermsOfService.css';
import logo from '../assets/Editvibelogo1.svg';

const TermsOfService = () => (
  <div className="evmp-terms-page">
    {/* Top-left logo linking back to app */}
    <a href="https://app.editvibe.ai" className="evmp-terms-logo-link">
      <img src={logo} alt="EditVibe Logo" className="evmp-terms-logo" />
    </a>

    <h1 className="evmp-terms-title">Terms of Service</h1>
    <p className="evmp-terms-updated"><em>Last updated: May 14, 2025</em></p>

    <h2 className="evmp-terms-section-title">1. Acceptance of Terms</h2>
    <p className="evmp-terms-text">
      By creating an account or using EditVibe (“we,” “us,” “our”), you agree to these Terms of Service (“Terms”). If you do not agree, please do not use our service.
    </p>

    <h2 className="evmp-terms-section-title">2. Services &amp; Accounts</h2>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item"><strong>Models &amp; Credits</strong>
        <ul className="evmp-terms-list">
          <li className="evmp-terms-list-item">Every new account receives 1,150 free credits.</li>
          <li className="evmp-terms-list-item">You may use those credits on our AI models: EditVibe‑CUT (precision trims) and EditVibe‑95 (full edits).</li>
          <li className="evmp-terms-list-item">When you exhaust free credits, you can purchase additional credits or subscribe to a paid membership plan.</li>
        </ul>
      </li>
      <li className="evmp-terms-list-item"><strong>Research Preview</strong>
        <ul className="evmp-terms-list">
          <li className="evmp-terms-list-item">Some models (e.g. EditVibe‑95) are marked Research Preview.</li>
          <li className="evmp-terms-list-item">You acknowledge those models may have slower processing times or varying results as we refine capabilities, improve delivery speed, and expand creative range.</li>
        </ul>
      </li>
    </ul>

    <h2 className="evmp-terms-section-title">3. How It Works</h2>
    <ol className="evmp-terms-list">
      <li className="evmp-terms-list-item">Upload your video (up to 10 minutes).</li>
      <li className="evmp-terms-list-item">Describe what you want (text prompt or timecodes).</li>
      <li className="evmp-terms-list-item">Receive a fully edited video.</li>
      <li className="evmp-terms-list-item">Download your finished file.</li>
    </ol>

    <h2 className="evmp-terms-section-title">4. User Content &amp; Ownership</h2>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item">You retain all rights to the videos you upload.</li>
      <li className="evmp-terms-list-item">By uploading, you grant EditVibe a non‑exclusive, worldwide, royalty‑free license to use, process, and store your content for service delivery and improvement.</li>
      <li className="evmp-terms-list-item">You represent and warrant that you own (or have permission to use) all rights in uploaded content.</li>
    </ul>

    <h2 className="evmp-terms-section-title">5. Prohibited Content</h2>
    <p className="evmp-terms-text">
      You may not upload or process videos that:
    </p>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item">Are sexually explicit, pornographic, or intended to arouse.</li>
      <li className="evmp-terms-list-item">Contain graphic violence, gore, hate speech, or credible threats.</li>
      <li className="evmp-terms-list-item">Promote illegal activities (e.g., drug manufacture, copyright infringement).</li>
      <li className="evmp-terms-list-item">Violate any third‑party rights (IP, privacy, publicity).</li>
    </ul>
    <p className="evmp-terms-text">
      We reserve the right to remove prohibited content, suspend or terminate offending accounts, and report activity to authorities.
    </p>

    <h2 className="evmp-terms-section-title">6. Payments &amp; Credits</h2>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item">All credit purchases and subscription fees are non‑refundable, except as required by law.</li>
      <li className="evmp-terms-list-item">We may offer free trials, promotions, or discounts at our discretion.</li>
      <li className="evmp-terms-list-item">Prices are displayed in your local currency. We reserve the right to modify pricing with notice.</li>
    </ul>

    <h2 className="evmp-terms-section-title">7. Disclaimers &amp; No Warranty</h2>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item"><strong>OUR SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE.”</strong></li>
      <li className="evmp-terms-list-item">We expressly disclaim all warranties, whether express or implied, including merchantability, fitness for a particular purpose, and non‑infringement.</li>
      <li className="evmp-terms-list-item">While we strive for accuracy, AI‑generated edits may include artifacts or require human review, especially during Research Preview.</li>
    </ul>

    <h2 className="evmp-terms-section-title">8. Limitation of Liability</h2>
    <p className="evmp-terms-text">
      To the fullest extent permitted by law, EditVibe and its affiliates will not be liable for:
    </p>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item">Any indirect, incidental, special, or consequential damages.</li>
      <li className="evmp-terms-list-item">Loss of profits, data, or goodwill.</li>
      <li className="evmp-terms-list-item">Costs of procurement of substitute services.</li>
    </ul>

    <h2 className="evmp-terms-section-title">9. Indemnification</h2>
    <p className="evmp-terms-text">
      You agree to defend, indemnify, and hold harmless EditVibe and its officers, directors, and employees from any claim, loss, liability, or expense arising out of your use of the Service or violation of these Terms.
    </p>

    <h2 className="evmp-terms-section-title">10. Governing Law &amp; Disputes</h2>
    <ul className="evmp-terms-list">
      <li className="evmp-terms-list-item">These Terms are governed by the laws of the State of Arizona, U.S.</li>
      <li className="evmp-terms-list-item">Any dispute will be resolved in the state or federal courts located in Maricopa County, Arizona.</li>
    </ul>

    <h2 className="evmp-terms-section-title">11. Changes to Terms</h2>
    <p className="evmp-terms-text">
      We may modify these Terms at any time. We’ll post changes here and update the “Last updated” date. Continued use after changes constitutes acceptance.
    </p>

    <h2 className="evmp-terms-section-title">12. Contact Us</h2>
    <p className="evmp-terms-text">
      Questions or concerns? Reach us at: <a href="mailto:info@editvibe.ai" className="evmp-terms-link">info@editvibe.ai</a>
    </p>
  </div>
);

export default TermsOfService;
